import { render, staticRenderFns } from "./ItemGaleria.vue?vue&type=template&id=606ecc4a&scoped=true&"
import script from "./ItemGaleria.vue?vue&type=script&lang=js&"
export * from "./ItemGaleria.vue?vue&type=script&lang=js&"
import style0 from "./ItemGaleria.vue?vue&type=style&index=0&id=606ecc4a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606ecc4a",
  null
  
)

export default component.exports